<div class="flex flex-col items-center p-5 text-center">
  <div class="flex justify-between w-full mb-1">
    <h2 class="text-primary-dark font-bold text-xl">
      Usuários com este cargo
    </h2>
    <button mat-icon-button (click)="close()">
      <mat-icon class="text-gray-500">close</mat-icon>
    </button>
  </div>
  
  <div class="w-full text-left text-gray-500 text-sm mb-4">
    {{ users.length }} usuários ao todo
  </div>
  
  <div class="w-full">
    <div *ngFor="let user of users" class="flex items-center justify-between py-3">
      <div class="flex items-center">
        <div class="mr-3">
          <img [src]="user.avatarUrl" alt="user" 
            class="w-10 h-10 rounded-full object-cover mr-2"
            onerror="this.src='assets/img/profile_placeholder.png'" />
        </div>
        <div class="font-medium text-gray-800">{{ user.name }}</div>
      </div>
      <div class="text-sm text-gray-500" *ngIf="user.createdAt">
        Desde {{ user.createdAt | date:'d MMM yyyy':'':'pt-BR' }}
      </div>
    </div>
    
    <div *ngIf="users.length === 0" class="py-4 text-center text-gray-500">
      Nenhum usuário está vinculado a este cargo.
    </div>
  </div>
</div>